"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUnknownSdkIngestionAttribution = exports.createIngestionAttribution = exports.classifyIngestionSdkVersion = exports.extractBaseIngestionSdkVersion = exports.normalizeIngestionSdkName = exports.getEntellicaHeaderValue = exports.ENTELLICA_SDK_LATEST_MAJOR = exports.UNKNOWN_INGESTION_SDK_VALUE = void 0;
const compareVersions_1 = require("../utils/compareVersions");
exports.UNKNOWN_INGESTION_SDK_VALUE = "unknown";
exports.ENTELLICA_SDK_LATEST_MAJOR = {
    python: 4,
    javascript: 5,
};
const getHeaderValue = (headers, name) => {
    if (!headers)
        return "";
    const directValue = headers[name];
    if (typeof directValue === "string")
        return directValue;
    const underscoreValue = headers[name.replaceAll("-", "_")];
    if (typeof underscoreValue === "string")
        return underscoreValue;
    return "";
};
const normalizeSdkValue = (value) => value || exports.UNKNOWN_INGESTION_SDK_VALUE;
exports.getEntellicaHeaderValue = getHeaderValue;
const normalizeIngestionSdkName = (sdkName) => {
    const normalized = sdkName?.trim().toLowerCase();
    if (!normalized || normalized === exports.UNKNOWN_INGESTION_SDK_VALUE) {
        return null;
    }
    if (normalized === "python" || normalized === "entellica-python") {
        return "python";
    }
    if ([
        "javascript",
        "js",
        "typescript",
        "ts",
        "entellica-js",
        "entellica-ts",
        "@entellica/client",
        "@entellica/browser",
        "@entellica/core",
        "@entellica/langchain",
        "@entellica/otel",
        "@entellica/openai",
        "@entellica/tracing",
        "@entellica/vercel-ai-sdk",
    ].includes(normalized)) {
        return "javascript";
    }
    return null;
};
exports.normalizeIngestionSdkName = normalizeIngestionSdkName;
const extractBaseIngestionSdkVersion = (sdkVersion) => {
    const version = sdkVersion.trim();
    if (/^v?\d+\.\d+\.\d+(?:[-+].+)?$/i.test(version)) {
        return version.split(/[-+]/)[0] ?? version;
    }
    const pep440Match = version.match(/^(v?\d+\.\d+\.\d+)(?:a|b|rc)\d+$/i);
    if (pep440Match?.[1]) {
        return pep440Match[1];
    }
    return version;
};
exports.extractBaseIngestionSdkVersion = extractBaseIngestionSdkVersion;
const classifyIngestionSdkVersion = (params) => {
    const sdkName = params.sdkName?.trim();
    const sdkVersion = params.sdkVersion?.trim();
    if (!sdkName ||
        !sdkVersion ||
        sdkName === exports.UNKNOWN_INGESTION_SDK_VALUE ||
        sdkVersion === exports.UNKNOWN_INGESTION_SDK_VALUE) {
        return {
            canonicalSdkName: null,
            latestMajor: null,
            major: null,
            status: "unknown",
        };
    }
    const canonicalSdkName = (0, exports.normalizeIngestionSdkName)(sdkName);
    if (!canonicalSdkName) {
        return {
            canonicalSdkName: null,
            latestMajor: null,
            major: null,
            status: "unsupported_sdk",
        };
    }
    const parsedVersion = (0, compareVersions_1.parseVersionString)((0, exports.extractBaseIngestionSdkVersion)(sdkVersion));
    const latestMajor = exports.ENTELLICA_SDK_LATEST_MAJOR[canonicalSdkName];
    if (!parsedVersion) {
        return {
            canonicalSdkName,
            latestMajor,
            major: null,
            status: "invalid_version",
        };
    }
    return {
        canonicalSdkName,
        latestMajor,
        major: parsedVersion.major,
        status: parsedVersion.major >= latestMajor ? "current" : "outdated_major",
    };
};
exports.classifyIngestionSdkVersion = classifyIngestionSdkVersion;
const createIngestionAttribution = (params) => {
    const { headers, authCheck } = params;
    return {
        ingestionApiKey: authCheck.scope.publicKey,
        ingestionSdkName: normalizeSdkValue(getHeaderValue(headers, "x-entellica-sdk-name")),
        ingestionSdkVersion: normalizeSdkValue(getHeaderValue(headers, "x-entellica-sdk-version")),
    };
};
exports.createIngestionAttribution = createIngestionAttribution;
const createUnknownSdkIngestionAttribution = (params) => ({
    ingestionApiKey: params.authCheck.scope.publicKey ?? "",
    ingestionSdkName: exports.UNKNOWN_INGESTION_SDK_VALUE,
    ingestionSdkVersion: exports.UNKNOWN_INGESTION_SDK_VALUE,
});
exports.createUnknownSdkIngestionAttribution = createUnknownSdkIngestionAttribution;
